import axios from "axios";
import { BASE_URL } from "../misc/Static_routes";
import { toast } from "react-toastify";
axios.defaults.withCredentials = true;

// REFACTOR: This need to be changed
const notifySuccess = (message) => toast.success(`${message}`, {});
const notifyError = (message) => toast.error(`${message}`, {});

export const getAllPins = () => {
  const result = axios
    .get(`${BASE_URL}/api/admin/pins`)
    .then((response) => {
      const responseOK =
        response && response.status === 200 && response.statusText === "OK";

      if (responseOK) {
        return response.data;
      }
    })
    .catch((error) => {
      console.log("error", error);
    });

  return result;
};

export const getAllPinsByCityName = (city_id) => {
  const result = axios
    .get(`${BASE_URL}/api/admin/pins/${city_id}`)
    .then((response) => {
      const responseOK =
        response && response.status === 200 && response.statusText === "OK";

      if (responseOK) {
        return response.data;
      }
    })
    .catch((error) => {
      console.log("error", error);
    });

  return result;
};

export const getPinById = (id) => {
  const result = axios
    .get(`${BASE_URL}/api/admin/pins/id/${id}`)
    .then((response) => {
      const responseOK =
        response && response.status === 200 && response.statusText === "OK";

      if (responseOK) {
        return response.data;
      }
    })
    .catch((error) => {
      console.log("error", error);
    });

  return result;
};

export const createPin = async (data, t) => {
  const result = axios
    .post(`${BASE_URL}/api/admin/pins`, data)
    .then((response) => {
      const responseOK =
        response && response.status === 200 && response.statusText === "OK";
      if (responseOK) {
        notifySuccess(t('successfullyCreatedPin'));
        return response.data;
      } else {
        notifyError(t('errorWhileCreatingPin'));
      }

      return result;
    });
};

export const updatePin = async (data, t) => {
  const result = axios
    .put(`${BASE_URL}/api/admin/pins`, data)
    .then((response) => {
      const responseOK =
        response && response.status === 200 && response.statusText === "OK";
      if (responseOK) {
        notifySuccess(t('successfullyUpdatedPin'));
        return response.data;
      } else {
        notifyError(t('errorWhileUpdatePin'));
      }

      return result;
    });
};

export const deletePin = (data, t) => {
  console.log("THE DATA", data);
  const result = axios
    .delete(`${BASE_URL}/api/admin/pins`, { data })
    .then((response) => {
      const responseOK =
        response && response.status === 200 && response.statusText === "OK";
      if (responseOK) {
        notifySuccess(t('successfullyDeletedPin'));
        return response.data;
      } else {
        notifyError(t('errorWhileDeletePin'));
      }

      return result;
    });
};
